// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"93":"list","180":"story"}[chunkId] || chunkId) + "-" + {"93":"d80c54b1db4204128c7f","180":"33d2cb5fb69087119014","669":"1ccd561a51c75e19b316"}[chunkId] + ".css";
};